import { isDefined } from './helpers';
import GLightbox from 'glightbox';

export function initLightBox()
{
    const lightbox = GLightbox({  });
}
